import logo from './logo.svg';
import React, { useRef, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Monitoring from './components/Monitoring';
import QRPayment from './components/qrpay/QRPayment';
import QRTicket from './components/qrpay/QRTicket';
import {userLanguage} from './config';
import PaymentGateWay from './components/qrpay/PaymentGateWay';
import FailPayment from './components/qrpay/FailPayment';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';

function App() {

    const appRef = useRef(null);

    const { i18n } = useTranslation(); // получаем объект i18n из хука

  
    useEffect(() => {
      // Проверяем, что i18n инициализирован и язык существует
      if (i18n.isInitialized && userLanguage && userLanguage !== i18n.language) {
        i18n.changeLanguage(userLanguage);
      }
    }, [userLanguage, i18n]);

    return (
        <div className="App">
            <main ref={appRef}>

                <Router>
                    <Routes>
                        <Route path="/" element={<Monitoring/>} />
                        <Route path="/monitoring" element={<Monitoring/>} />
                        <Route path="/qrpay" element={<QRPayment/>} />
                        <Route path="/pay" element={<PaymentGateWay />} />
                        <Route path="/pay/:qr" element={<PaymentGateWay/>} />
                        <Route path="/pay/ticket/:id" element={<QRTicket/>} />
                        <Route path="/pay/fail/:id" element={<FailPayment/>} />
                        <Route path="*" element={<QRPayment/>} />
                    </Routes>
                </Router>
            </main>
        </div>
    );
}

export default App;